import React from 'react'
import ProductGrid from './ProductGrid'

const Products = () => {
  return (
    <div>
        

        <img className='w-[95vw] md:w-[80vw] m-auto rounded-xl' src='/assets/images/livraison.png' alt='livraison electro titan' />


        <h1 id="nos-produits" className="
  text-center
  scroll-mt-20
  font-raleway
  font-regular
  text-2xl
  md:text-4xl
  tracking-wide
  text-gray-900
  mt-8
  md:mt-16
">
  Nos Produits
</h1>


<ProductGrid />

    </div>
  )
}

export default Products